module.exports = __webpack_public_path__ + "static/media/science_cooperation.784e312c.jpg";